module.exports = __webpack_public_path__ + "static/sphere_about_bg-b3f9228749e10b850f1b9a49228c6c30.png";